/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Linesheets_To_ApproveInputs */

const en_queue_linesheets_to_approve = /** @type {(inputs: Queue_Linesheets_To_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linesheets to approve`)
};

/**
* | output |
* | --- |
* | "Linesheets to approve" |
*
* @param {Queue_Linesheets_To_ApproveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_linesheets_to_approve = /** @type {((inputs?: Queue_Linesheets_To_ApproveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Linesheets_To_ApproveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_linesheets_to_approve(inputs)
});